<template>
  <div :class="[`${variantClasses[props.variant].container} rounded-2xl px-8 py-6`]">
    <div>
      <div class="mb-2" :class="[`${variantClasses[props.variant].title} text-lg`, { 'text-center': props.centered }]">{{ props.title }}</div>
      <slot>
        <div v-if="props.description" :class="[`${variantClasses[props.variant].description} whitespace-break-spaces`]">{{ props.description }}</div>
      </slot>
    </div>
    <div class="mt-5" v-if="$slots.actions">
      <slot name="actions" :variant="props.variant" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  variant?: 'destructive' | 'primary' | 'success';
  title: string;
  description?: string;
  centered?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
})

const variantClasses = {
  primary: {
    container: "bg-primary bg-opacity-10 border-2 border-primary",
    title: "text-white",
    description: "text-gray-300"
  },
  success: {
    container: "bg-success bg-opacity-10 border-2 border-success",
    title: "text-white",
    description: "text-gray-300"
  },
  destructive: {
    container: "bg-red-600 bg-opacity-10 border-2 border-red-600",
    title: "text-white",
    description: "text-gray-300"
  },
};
</script>
